// Shared comparator builders for sortable lists (resource categories + workbench).
//
// Each builder returns a `(a, b) => number` function for Array.prototype.sort.
// Missing / blank / unparseable values consistently sort to the END in both
// directions, so a chosen sort never scatters empty rows through the list.

// String compare; blank/missing values always sort to the end (both directions).
export const byString = (getStr, dir) => (a, b) => {
  const av = (getStr(a) ?? '').toString().trim();
  const bv = (getStr(b) ?? '').toString().trim();
  if (!av && !bv) return 0;
  if (!av) return 1;
  if (!bv) return -1;
  const result = av.localeCompare(bv, undefined, { sensitivity: 'base', numeric: true });
  return dir === 'asc' ? result : -result;
};

// Numeric compare; missing/non-finite values always sort to the end.
export const byNumber = (getNum, dir) => (a, b) => {
  const av = getNum(a);
  const bv = getNum(b);
  const aMissing = av == null || !Number.isFinite(av);
  const bMissing = bv == null || !Number.isFinite(bv);
  if (aMissing && bMissing) return 0;
  if (aMissing) return 1;
  if (bMissing) return -1;
  return dir === 'asc' ? av - bv : bv - av;
};

// Read a number-like field, returning null when absent/unparseable.
export const num = (field) => (item) => {
  const value = Number(item?.[field]);
  return Number.isFinite(value) ? value : null;
};

// Read a date-like field as epoch ms, returning null when absent/unparseable.
// (created_at is an RFC-1123 string from Flask; other date fields are best-effort
//  strings from search/scraping/user input — new Date(...) parses what it can.)
export const date = (field) => (item) => {
  const time = new Date(item?.[field]).getTime();
  return Number.isFinite(time) ? time : null;
};
